import React from "react";
import { Box, Stack, Typography } from "@mui/material";

import { appBarHeight, consoleBorder } from "./constants";

const DashboardContent = ({ activeItem, children, compactHeader = false, drawerWidth, header, headerless = false, title }) => (
  <Stack spacing={0} sx={{ minWidth: 0, flexGrow: 1, mt: appBarHeight, bgcolor: "background.paper" }}>
    {!headerless && (
      <Box
        sx={{
          minHeight: compactHeader ? 72 : 104,
          borderBottom: `1px solid ${consoleBorder}`,
          bgcolor: "background.paper",
          px: { xs: 2, sm: 3, md: compactHeader ? 3 : 4 },
          py: compactHeader ? { xs: 1.5, sm: 2 } : { xs: 2, sm: 2.5 },
          display: "flex",
          alignItems: "center",
          gap: 1.5,
        }}
      >
        <Box sx={{ minWidth: 0, flexGrow: 1 }}>
          {header || (
            <>
              <Typography variant="h6" sx={{ fontWeight: 800 }} noWrap>
                {activeItem.label || title || "Dashboard"}
              </Typography>
              {!!activeItem.description && (
                <Typography variant="body2" color="text.secondary" noWrap>
                  {activeItem.description}
                </Typography>
              )}
            </>
          )}
        </Box>
      </Box>
    )}
    <Box sx={{ p: { xs: 2, sm: 3, md: compactHeader ? 3 : 4 }, pt: { xs: 2, sm: 3 }, minWidth: 0 }}>
      {children}
    </Box>
  </Stack>
);

export default DashboardContent;
